import { IComponentOptions } from 'angular';
import { ManageUsersCtrl } from './manage-users.controller';

export const ManageUsersComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    schoolUsers: '<',
    currentUser: '<',
  },
  controller: ManageUsersCtrl,
  template: require('./manage-users.html'),
};
